import React, { useEffect, useState } from "react";
import { ReactTyped } from "react-typed";
import { getAllWhatToDosShort } from "../../services/whatToDoService";
import { getAllPcesShort } from "../../services/pceService";
import Skeleton from "react-loading-skeleton";
import "react-loading-skeleton/dist/skeleton.css";
import "swiper/css";
import "swiper/css/navigation";
import { Swiper, SwiperSlide } from "swiper/react";
import { Navigation, Pagination, Autoplay } from "swiper/modules";
import { Link } from "react-router-dom";

const InfoCard = () => {
	const [texts, setTexts] = useState([]);
	const [icons, setIcons] = useState([]);
	const [loading, setLoading] = useState(true);

	useEffect(() => {
		Promise.all([getAllWhatToDosShort(), getAllPcesShort()])
			.then(([whatToDo, pce]) => {
				const pceTexts = pce.data.data.map(
					(item) => `Cosa sono le <strong>${item.label}</strong>?`
				);
				const whatToDoTexts = whatToDo.data.data.map(
					(item) => `Cosa fare in caso di <strong>${item.label}</strong>?`
				);
				const whatToDoIcons = whatToDo.data.data.map((item) => ({
					...item,
					link: `/what-to-do/${item.id}`,
				}));
				const pceIcons = pce.data.data.map((item) => ({
					...item,
					link: `/pce/${item.id}`,
				}));
				setIcons([...pceIcons, ...whatToDoIcons]);
				setTexts([...pceTexts, ...whatToDoTexts]);
			})
			.finally(() => setLoading(false));
	}, []);

	if (loading) {
		return (
			<div className="p-4 flex flex-col items-center h-full">
				<div className="w-full h-full">
					<Skeleton height={"10%"} className="mb-4" />
					<Skeleton height={"80%"} />
				</div>
			</div>
		);
	}

	return (
		<div className="p-4 flex flex-col items-center h-full">
			<div className="text-xl md:text-2xl lg:text-3xl text-blue-600 mb-10">
				<ReactTyped strings={texts} typeSpeed={60} backSpeed={50} loop />
			</div>
			<Swiper
				modules={[Navigation, Pagination, Autoplay]}
				spaceBetween={1}
				slidesPerView={1}
				navigation
				pagination={{ clickable: true }}
				loop={true}
				autoplay={{
					delay: 3000,
					disableOnInteraction: false,
				}}
				breakpoints={{
					640: { slidesPerView: 1 },
					1100: { slidesPerView: 2 },
					1500: { slidesPerView: 3 },
				}}
				className="w-full"
			>
				{icons.map((icon, index) => (
					<SwiperSlide key={index}>
						<Link to={icon.link}>
							<div className="flex flex-col items-center text-center p-5">
								<img alt="" src={icon.src} className="w-32 h-32 cursor-pointer" />
								<p className="text-xl mt-2 cursor-pointer">{icon.label}</p>
							</div>
						</Link>
					</SwiperSlide>
				))}
			</Swiper>
		</div>
	);
};

export default InfoCard;
